import React, { Component } from 'react';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import "./qrcheck.scss";

class Qrcheck extends Component {
    constructor(props) {
        super(props);
        this.state = {
            joborder_code: '',
            username: '',
            password: '',
            errorMessage: ''
        };
    }

    componentDidMount() {
        // Retrieve joborder_code from URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const joborder_code = urlParams.get('joborder_code');
        this.setState({ joborder_code });
    }
    handleLogin = (event, errors, values) => {
        // Prevent form submission if there are validation errors
        if (errors.length === 0) {
            const { username, password, joborder_code } = this.state;

            // Check if the credentials match "mypolice"
            if (username === 'mypolice' && password === 'mypolice') {
                // Redirect to the job order page on successful login
                window.location.href = `https://thailandsmarttour.dot.go.th/joborder/paper/${joborder_code}`;
            } else {
                // Display an error message if credentials are incorrect
                this.setState({ errorMessage: 'ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง' });
            }
        }
    }

    render() {
        const { errorMessage } = this.state;

        return (
            <React.Fragment>
                <div className="login-page">
                    <div className="style-login">
                        <div className="box-flex-1">
                            <div className="box-logo">
                                <img
                                    className="logo-img"
                                    src={"/assets/images/icon/login.png"}
                                    alt="Login Logo"
                                />
                            </div>
                        </div>
                        <div className="box-flex-2">
                            <div className="card-login">
                                <span className="card-text">เข้าสู่ระบบ</span>
                                <div className="style-card-login">
                                    <AvForm className="form-horizontal" onSubmit={this.handleLogin}>
                                        <div className="form-group normal-text">
                                            <AvField
                                                name="username"
                                                label="ชื่อผู้ใช้งาน"
                                                className="form-control"
                                                placeholder="กรอกชื่อผู้ใช้งาน"
                                                type="text"
                                                required
                                                onChange={(e) => this.setState({ username: e.target.value })}
                                            />
                                        </div>
                                        <div className="form-group normal-text">
                                            <AvField
                                                name="password"
                                                label="รหัสผ่าน"
                                                type="password"
                                                required
                                                placeholder="กรอกรหัสผ่าน"
                                                onChange={(e) => this.setState({ password: e.target.value })}
                                            />
                                        </div>
                                        {errorMessage && <div className="mb-2" style={{ color: 'red' }}>{errorMessage}</div>}
                                        <div className="form-group">
                                            <button
                                                className="btn btn-primary btn-block waves-effect waves-light"
                                                type="submit"
                                            >
                                                <span className="normal-text-18">ยืนยัน</span>
                                            </button>
                                        </div>
                                    </AvForm>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Qrcheck;
